import { Capacitor } from '@capacitor/core';
export function getPlatform() {
    if (Capacitor.isNativePlatform()) {
        return 'capacitor';
    }
    // Check if running on mobile web
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent);
    return isMobile ? 'mobile-web' : 'web';
}
/**
 * Get fresh notification permission status directly from browser
 * This avoids relying on cached values that might be stale
 */
export function getFreshPermissionStatus() {
    if ('Notification' in window) {
        return Notification.permission;
    }
    return 'denied';
}
/**
 * Check if notifications are enabled in app settings
 */
export function areNotificationsEnabledInApp() {
    return localStorage.getItem('notifications-enabled') !== 'false';
}
/**
 * Check if user has been asked for permissions before
 */
export function hasAskedForPermissionBefore() {
    return localStorage.getItem('notification-permission-asked') === 'true';
}
/**
 * Check if user has been asked after challenge creation
 */
export function hasAskedAfterChallengeCreation() {
    return localStorage.getItem('notification-asked-after-creation') === 'true';
}
/**
 * Comprehensive check for whether notification banner should be shown
 */
export function shouldShowNotificationBanner() {
    const permission = getFreshPermissionStatus();
    const notificationsEnabled = areNotificationsEnabledInApp();
    const hasAskedBefore = hasAskedForPermissionBefore();
    // Show banner only if:
    // 1. Notifications are supported
    // 2. Permission is default (never asked)  
    // 3. User hasn't been asked before
    // 4. Notifications are enabled in app settings
    const shouldShow = ('Notification' in window &&
        permission === 'default' &&
        !hasAskedBefore &&
        notificationsEnabled);
    return shouldShow;
}
/**
 * Check if post-challenge notification prompt should be shown
 */
export function shouldShowPostChallengePrompt() {
    const permission = getFreshPermissionStatus();
    const notificationsEnabled = areNotificationsEnabledInApp();
    const hasAskedAfterCreation = hasAskedAfterChallengeCreation();
    // Show prompt if:
    // 1. Notifications are supported
    // 2. Permission is default BUT notifications are enabled globally
    // 3. OR permission is granted BUT notifications are disabled
    // 4. AND we haven't asked after creation before
    const needsPermission = permission === 'default' && notificationsEnabled;
    const needsReEnable = permission === 'granted' && !notificationsEnabled;
    const shouldShow = ('Notification' in window &&
        (needsPermission || needsReEnable) &&
        !hasAskedAfterCreation);
    return shouldShow;
}
